const NOTE_ROUTE_PATTERN = /^\/n\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i
const CONTEXT_ROUTE_PATTERN = /^\/c\/([a-zA-Z0-9_%.-]+)\/?$/
const ADMIN_ROUTE_PATTERN = /^\/admin(?:\/|$)/i

interface RouteHistory {
  readonly state: unknown
  replaceState(data: unknown, unused: string, url?: string | URL | null): void
}

interface GuardHistory extends RouteHistory {
  pushState(data: unknown, unused: string, url?: string | URL | null): void
}

function currentHistory(): RouteHistory {
  return window.history
}

export function readNoteRoute(pathname = window.location.pathname): string | null {
  return NOTE_ROUTE_PATTERN.exec(pathname)?.[1]?.toLowerCase() ?? null
}

export function readContextRoute(pathname = window.location.pathname): string | null {
  const match = CONTEXT_ROUTE_PATTERN.exec(pathname)?.[1]
  if (!match) return null
  try { const id = decodeURIComponent(match); return /^[a-zA-Z0-9][a-zA-Z0-9_.:% -]{0,199}$/.test(id) ? id : null } catch { return null }
}
export function contextPath(id: string): string { return `/c/${encodeURIComponent(id)}` }
/** The Links screen (links/library/): one address, no ids. */
export function readLinksRoute(pathname = window.location.pathname): boolean {
  return /^\/links\/?$/.test(pathname)
}
export function replaceLinksRoute(history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', '/links')
}
export function readContextCollectionRoute(pathname = window.location.pathname): boolean {
  return /^\/contexts\/?$/.test(pathname)
}
export function replaceContextCollectionRoute(history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', '/contexts')
}
export function replaceContextRoute(id: string, history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', contextPath(id))
}

export function readAdminRoute(pathname = window.location.pathname): boolean {
  return ADMIN_ROUTE_PATTERN.test(pathname)
}

export function adminPath(): string {
  return '/admin'
}

export function notePath(noteId: string): string {
  return `/n/${noteId.toLowerCase()}`
}

export function replaceNoteRoute(
  noteId: string,
  history: RouteHistory = currentHistory(),
): void {
  history.replaceState(history.state, '', notePath(noteId))
}

export function clearNoteRoute(history: RouteHistory = currentHistory()): void {
  history.replaceState(history.state, '', '/')
}

export function pushGuardedRouteEntry(
  baseState: unknown,
  guardState: unknown,
  history: GuardHistory = window.history,
  pathname = window.location.pathname,
  search = typeof window === 'undefined' ? '' : window.location.search,
): void {
  const routeNoteId = readNoteRoute(pathname)
  const guardedPath = routeNoteId
    ? notePath(routeNoteId)
    : readContextRoute(pathname)
      ? contextPath(readContextRoute(pathname)!)
    : readContextCollectionRoute(pathname)
      ? '/contexts'
    : readLinksRoute(pathname)
      ? '/links'
    : readAdminRoute(pathname)
      ? pathname + search
      : null
  if (!guardedPath) {
    history.pushState(guardState, '')
    return
  }
  history.replaceState(baseState, '', '/')
  history.pushState(guardState, '', guardedPath)
}
